import { defaultHttpClient } from '../../httpClient';
import type { GetMarketGoodsCarouselResponse } from './type';

export const getMarketGoodsCarousel = (marketId: number) => {
  return defaultHttpClient
    .request<GetMarketGoodsCarouselResponse>({
      // url: `/api/v2/markets/${marketId}/goods-carousels/`,
      url: `/api/v2/markets/${marketId}/goods_carousels/`,
      method: 'GET',
    })
    .then(result => result.data);
};
